import { PageShell } from "../components/Layout";
import { SectionLabel, SplitButton } from "../components/ui";

export default function NotFound() {
  return (
    <PageShell inverseHeader>
      <main id="main-content" className="editorial-page" tabIndex={-1}>
        <section className="page-hero page-hero--dark" aria-labelledby="not-found-heading">
          <div className="page-hero__copy">
            <SectionLabel inverse>خطای ۴۰۴</SectionLabel>
            <h1 id="not-found-heading">این صفحه پیدا نشد</h1>
            <p>ممکن است آدرس تغییر کرده باشد یا پیوندی که باز کرده‌اید کامل نباشد.</p>
            <SplitButton to="/" variant="copper">بازگشت به صفحه اصلی</SplitButton>
          </div>
        </section>
      </main>
    </PageShell>
  );
}
